<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="169.572" height="37.599" viewBox="0 0 169.572 37.599" class="loading">
        <g id="Loading_track" data-name="Loading track" transform="translate(-79.269 -486.592)">
            <g v-for="(hoof, index) in hoofPrints" :key="index" :style="{ opacity: hoofOpacity[index] }" :transform="hoof.transform">
                <path
                    id="Footprint"
                    d="M272.709,361.016c-2.83-.372-2.52-4.448-2.071-5.825a17.279,17.279,0,0,0,1.035-5.405c-.1-1.618-.345-4.441.345-4.717s2.278,2.307,3.21,4.614a13.747,13.747,0,0,1,1.243,6.2C276.472,358.531,275.54,361.388,272.709,361.016Zm-5.8-.007c1.588.138,2.382-1.893,2.451-3.822s-1.691-5.612-2-6.61a9.465,9.465,0,0,1-.142-3.167c.069-.448.414-2.375-.311-2.341s-1.726,1.48-2.658,3.787a17.846,17.846,0,0,0-1.484,6.851A5.035,5.035,0,0,0,266.911,361.01Z"
                    transform="translate(-262.758 -345.049)"
                />
            </g>
        </g>
    </svg>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const generateRandomRotation = (baseAngle, variation) => {
    return baseAngle + (Math.random() * variation - variation / 2);
};

const positions = [
    { x: 95.738, y: 505.482, baseAngle: 87 },
    { x: 126.622, y: 486.592, baseAngle: 87 },
    { x: 161.376, y: 503.061, baseAngle: 86 },
    { x: 195.124, y: 486.592, baseAngle: 87 },
    { x: 219.376, y: 510.199, baseAngle: 88 },
    { x: 248.124, y: 494, baseAngle: 86 },
];
const hoofPrints = ref([]);
onMounted(() => {
    hoofPrints.value = positions.map((pos, index) => {
        const angleVariation = index % 2 === 0 ? 10 : -10; // Top ones tilt up, bottom ones tilt down
        const randomizedAngle = generateRandomRotation(pos.baseAngle, 20);

        return {
            transform: `translate(${pos.x} ${pos.y}) rotate(${randomizedAngle})`,
        };
    });
});

// const hoofPrints = ref(
//   positions.map((pos, index) => {
//     const angleVariation = index % 2 === 0 ? 10 : -10;
//     const randomizedAngle = generateRandomRotation(pos.baseAngle, 20);

//     return {
//       transform: `translate(${pos.x} ${pos.y}) rotate(${randomizedAngle})`,
//     };
//   })
// );

const hoofOpacity = ref([0.08, 0.2, 0.4, 0.6, 0.8, 1]);

const animationSpeed = 380;

onMounted(() => {
    setInterval(() => {
        hoofOpacity.value.unshift(hoofOpacity.value.pop());
    }, animationSpeed);
});
</script>

<style scoped>
.loading {
    fill: var(--on-surface);
}
</style>
